import React, { ChangeEvent } from 'react'
import classNames from 'classnames'
import { ArrowDropDown } from '@material-ui/icons'

export type SelectItem = {
  label: string
  value: string
  metaAttributes?: object
}

function SelectInputField({
  className,
  id,
  name,
  placeholder,
  label,
  defaultValue,
  items,
  onChange,
  onBlur,
  error,
}: {
  className: string
  id: string
  name: string
  placeholder: string
  label: string
  defaultValue: string
  items: SelectItem[]
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void
  onBlur: (e: ChangeEvent<HTMLSelectElement>) => void
  error: string
}) {
  return (
    <div className="first:mt-0 desktop:mt-8 tablet:mt-8 sp:mt-8">
      <label
        htmlFor={id}
        className="block text-left font-bold font-yu-gothic text-text-black"
      >
        {label}
      </label>
      <div className={classNames('desktop:mt-3 tablet:mt-3 sp:mt-3 relative')}>
        <select
          id={id}
          name={name}
          className={className}
          onChange={onChange}
          onBlur={onBlur}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {items.map(item => {
            return (
              <option
                key={item.value}
                value={item.value}
                {...(item.metaAttributes || {})}
                selected={defaultValue === item.value}
              >
                {item.label}
              </option>
            )
          })}
        </select>
        <div className="absolute top-1/2 right-0 transform -translate-y-1/2 pointer-events-none cursor-pointer">
          <ArrowDropDown />
        </div>
      </div>
      {error && (
        <span
          id={`${id}_error`}
          className="block text-left font-yu-gothic text-notify-red desktop:mt-4 tablet:mt-4 sp:mt-4"
        >
          {error}
        </span>
      )}
    </div>
  )
}

export default SelectInputField
